export enum ProvisionType {
  Instant = "instant",
  Processed = "processed",
}
